import _regeneratorRuntime from '/var/www/html/node_modules/babel-runtime/regenerator';
import _JSON$stringify from '/var/www/html/node_modules/babel-runtime/core-js/json/stringify';
import _asyncToGenerator from '/var/www/html/node_modules/babel-runtime/helpers/asyncToGenerator';
import axios from 'axios';
import cookie from 'cookie';
import uuid from 'uuid';

//error({statusCode: 204, message: "The server successfully processed the request and is not returning any content."})


export default (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(context) {
    var _this = this;

    var websiteCookies, res, geoCountryCode;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:

            //
            // axios default headers
            //
            global.resetAxiosHeaders = function () {
              if (process.client) {
                //
                // set x-cookies
                //
                var xCookies = document.cookie;
                xCookies = xCookies.replace(/session_lastSearchResults=.*?(;|$)/i, '');
                xCookies = xCookies.replace(/local_token=.*?(;|$)/i, '');
                xCookies = xCookies.replace(/websiteSettings=.*?(;|$)/i, '');
                axios.defaults.headers.common['X-Cookie'] = xCookies;
              }
            };

            //
            // set global lang
            //
            if (context.route && context.route.params && context.route.params.lang && !global.selectedLang) {
              global.selectedLang = context.route.params.lang;
            }

            global.hostname = process.server ? context.req.headers['host'] : window.location.host;

            if (!process.server) {
              _context5.next = 8;
              break;
            }

            _context5.next = 6;
            return axios.get(process.env.apiInternalEndpoint + 'api/common/website/' + global.hostname).then(function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
                var reqCookies, cookies, cookieOptions, expDate, cookieName;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:

                        // get request cookies
                        reqCookies = {};

                        if (context.req.headers.cookie) {
                          reqCookies = cookie.parse(context.req.headers.cookie);
                        }

                        // get default utm_payment
                        global.utmPayment = reqCookies.utm_payment ? reqCookies.utm_payment : null;

                        global.websiteSettings = res.data;
                        cookies = [];
                        cookieOptions = { path: '/' };


                        if (global.websiteSettings.extra_info.cookie_domain) {
                          cookieOptions.domain = global.websiteSettings.extra_info.cookie_domain;
                        }

                        expDate = new Date(); //;

                        expDate.setFullYear(expDate.getFullYear() + 10);
                        cookieOptions.expires = expDate;

                        // set website settings cookie
                        cookies.push(cookie.serialize('websiteSettings', _JSON$stringify(global.websiteSettings), cookieOptions));

                        // default language cookie
                        if (context.route && context.route.params && context.route.params.lang && context.route.params.lang.length == 2) {
                          cookies.push(cookie.serialize('utm_language', context.route.params.lang, cookieOptions));
                        } else {
                          cookies.push(cookie.serialize('utm_language', 'en', cookieOptions));
                        }

                        // set utm cookies
                        for (cookieName in context.route.query) {
                          if (cookieName.search('utm_') === 0 || cookieName.search('gclid') === 0 || cookieName.search('test_country') === 0) {
                            cookies.push(cookie.serialize(cookieName, context.route.query[cookieName], cookieOptions));
                            if (cookieName == 'utm_payment') {
                              global.utmPayment = context.route.query[cookieName];
                            }
                          }
                        }

                        // set utm_referer
                        if (context.route.fullPath && !reqCookies.utm_referer) {
                          cookies.push(cookie.serialize('utm_referer', context.route.fullPath, cookieOptions));
                        }

                        // set uuid cookie
                        if (!reqCookies.uuid) {
                          cookies.push(cookie.serialize('uuid', uuid.v4(), cookieOptions));
                        }

                        context.res.setHeader('Set-Cookie', cookies);

                      case 16:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this);
              }));

              return function (_x2) {
                return _ref2.apply(this, arguments);
              };
            }()).catch(function (err) {
              console.log('Error');
              console.log(err);
            });

          case 6:
            _context5.next = 12;
            break;

          case 8:
            websiteCookies = cookie.parse(document.cookie);

            global.websiteSettings = websiteCookies.websiteSettings ? JSON.parse(websiteCookies.websiteSettings) : {};
            global.utmPayment = websiteCookies.utm_payment ? websiteCookies.utm_payment : null;
            global.resetAxiosHeaders();

          case 12:

            //
            // endpoint
            //
            global.getEndPoint = function () {
              var endPoint = process.env.apiInternalEndpoint;
              if (process.client) {
                endPoint = global.websiteSettings.extra_info.api_endpoint;
              }
              return endPoint;
            };

            //
            // Stop all traffic from EG
            //
            _context5.next = 15;
            return axios.get(global.getEndPoint() + 'api/common/geo-country');

          case 15:
            res = _context5.sent;
            geoCountryCode = res.data.country;

            global.showErrorPage = false;
            if (geoCountryCode == 'EG') {
              global.showErrorPage = true;
              context.error({ statusCode: 500, message: "Page Not Found" });
            }

            global.getTheme = function () {
              if (global.hostname == 'www.peopleuncover.com' || global.hostname == 'www.detectpeople.com') {
                return 'purple';
              } else {
                return global.websiteSettings.theme;
              }
            };

            global.getLogoPath = function () {
              if (typeof global.websiteSettings.extra_info['logo_file_' + this.lang] != 'undefined') {
                return global.getEndPoint() + global.websiteSettings.extra_info['logo_file_' + this.lang];
              } else if (typeof global.websiteSettings.extra_info.logo_file != 'undefined') {
                return global.getEndPoint() + global.websiteSettings.extra_info.logo_file;
              }
              return null;
            };

            global.getFaviconPath = function () {
              if (typeof global.websiteSettings.extra_info.favicon_file != 'undefined' && global.websiteSettings.extra_info.favicon_file != '') {
                return global.getEndPoint() + global.websiteSettings.extra_info.favicon_file;
              }
              return null;
            };

            //
            // init website settings
            //
            _context5.next = 24;
            return axios.get(global.getEndPoint() + 'api/common/countries').then(function (res) {
              global.countryByCode = res.data.data;
            });

          case 24:
            global.getCountryByCode = function (code) {
              if (typeof global.countryByCode[code] != 'undefined') {
                return global.countryByCode[code];
              }
              return code;
            };
            global.getPayPalStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      if (!['US'].includes(geoCountryCode)) {
                        _context2.next = 2;
                        break;
                      }

                      return _context2.abrupt('return', global.websiteSettings.extra_info['paypal_status'] == 1);

                    case 2:
                      return _context2.abrupt('return', false);

                    case 3:
                    case 'end':
                      return _context2.stop();
                  }
                }
              }, _callee2, this);
            }));
            global.getPaypalClientId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      return _context3.abrupt('return', global.websiteSettings.config['PAYPAL_CLIENT_ID']);

                    case 1:
                    case 'end':
                      return _context3.stop();
                  }
                }
              }, _callee3, this);
            }));
            global.getPaymentMethodId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
              return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      return _context4.abrupt('return', global.websiteSettings.extra_info['payment_package_unique_identifier'].toLowerCase());

                    case 2:
                    case 'end':
                      return _context4.stop();
                  }
                }
              }, _callee4, this);
            }));

          case 28:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
})();


//////////////////
// WEBPACK FOOTER
// ./plugins/website.js
// module id = ./plugins/website.js
// module chunks = 54